import { createSelector } from 'reselect'

export default createSelector(
	[ state => state.oeq.timer ],
	timer => timer
)
